// node modules
import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
// actions
import { getCheckoutReport } from '../../../redux/checkouts/reports/actions';
// Constants
import { reportColumns } from '../../../enums/columns/checkouts';
// Components
import Table from '../../../components/table';
import ReservesCheckoutReportModal from './ReservesCheckoutReportModal';
import CheckoutReportModal from './CheckoutReportModal';
//enums
import ENUMS from '../../../enums';
//utils
import submitForm from '../../../utils/submitForm';

const pageSize = 10;
let selectedRecordId;
let selectedCafeName = '';

function CheckoutReport() {
  let formRefrence = useRef();
  const dispatch = useDispatch();
  const state = useSelector(state => state.checkoutReportsReducer);
  const [currentPage, setCurrentPage] = useState(1);
  const [showReserveModal, setShowReserveModal] = useState('');
  const [sortType, setSortType] = useState('desc');
  const [sortBy, setSortBy] = useState('startAt');
  const [sort, setSort] = useState('');
  const [filter, setFilter] = useState('');
  const [cafeName, setCafeName] = useState('');

  const onPageChanged = pageNumber => {
    setCurrentPage(pageNumber);
    const query = buildSearchQuery(pageNumber, pageSize);
    dispatch(getCheckoutReport(query));
  };

  const checkoutSpecificRecord = item => {
    setShowReserveModal('checkout-modal');
    selectedRecordId = item.id;
    selectedCafeName = item.cafeName;
  };

  const checkoutReservationDetails = item => {
    setShowReserveModal('reserve-modal');
    selectedRecordId = item.id;
    selectedCafeName = item.cafeName;
  };
  const sortTable = (columnName) => {
    console.log("columnName", columnName)
    setSortBy(columnName);
    setSortType(sortType === 'asc' ? 'desc' : 'asc');

    const query = `${columnName}-${sortType}`;
    console.log(query)
    setSort(`${query}`);
    

  };


  const filterAndSort = () => {
    let searchQuery = buildSearchQuery(currentPage, pageSize);
    dispatch(getCheckoutReport(searchQuery));
  };

  const buildSearchQuery = (pageNumber, pageSize) => {
    if (!isNaN(pageNumber) && !isNaN(pageSize)) {
      let query = `pageNumber=${pageNumber}&pageSize=${pageSize}`;
      query += `&sort=${sort || 'startAt-desc'}`;
      if (filter) {
        query += '&' + filter;
      }
      return query;
    }
  };

  const applyFilters = (event) => {
    const queryString = submitForm(event);
    setFilter(queryString);
  };

  const resetForm = () => {
    Array.from(formRefrence.current).forEach(element => {
      if (element.name === 'resetButton') {
        element.value = locales('fields.reset');
      } else {
        element.value = null;
      }
    });
    setCafeName('');
    setFilter('');
  };

  useEffect(() => {
    setCurrentPage(currentPage);
    filterAndSort();
  }, [filter, sort]);


  return (
    <div>
      <h3 className='text-muted py-4'>
        <div className='text-right'>{locales('titles.checkoutReport')}</div>
      </h3>
      <div className='panel-heading'>
        <i className='fas fa-list-alt px-1'></i>
        لیست گزارش تسویه حساب از تاریخ : ۱۴۰۰/۰۱/۰۱&zwnj;
      </div>
      <div className='filter-part'>
        <form
          onReset={event => resetForm(event)}
          onSubmit={event => applyFilters(event)}
          id="form"
          ref={formRefrence}
          className="my-4"
        >
          <div className="col-12 d-flex justify-content-start">
            <label className="col-1 text-right filter-field-label">{locales('fields.cafe.name')}</label>
            <input
              name="cafeNamePart"
              type="text"
              value={cafeName}
              onChange={event => setCafeName(event.target.value)}
              className="form-control col-4"
              placeholder={locales('fields.cafe.name')}
              maxLength={ENUMS.MAX_LENGTH.cafeName}
              id="cafeNameInput"
            />
            <div className="mr-auto">
              <input
                name="resetButton"
                type="reset"
                value={locales('fields.reset')}
                className="btn btn-danger w-5 mx-2"
                maxLength="10"
              />
              <button
                type="submit"
                id="apply-filter-btn-cafe"
                className="btn btn-success w-5 mx-2"
                name="filter"
              >
                {locales('fields.applyFilters')}
              </button>
            </div>
          </div>
        </form>
      </div>
      <Table
        columns={reportColumns}
        dataSource={state.checkouts}
        loading={state.getCheckoutsLoading}
        action={{
          checkoutSpecificRecord: checkoutSpecificRecord,
          checkoutReservationDetails: checkoutReservationDetails,
        }}
        sort={{ type: sortType, action: sortTable }}
        pagination={{
          currentPage: currentPage,
          pageSize: pageSize,
          totalCount: state.checkout.totalRecords,
          onPageChange: onPageChanged,
        }}
      />
      {showReserveModal === 'reserve-modal' && (
        <ReservesCheckoutReportModal
          showReserveModal={showReserveModal}
          setShowReserveModal={setShowReserveModal}
          selectedRecordId={selectedRecordId}
          selectedCafeName={selectedCafeName}
        />
      )}
      {showReserveModal === 'checkout-modal' && (
        <CheckoutReportModal
          showReserveModal={showReserveModal}
          setShowReserveModal={setShowReserveModal}
          selectedRecordId={selectedRecordId}
          selectedCafeName={selectedCafeName}
          filterAndSort={filterAndSort}
        />
      )}
    </div>
  );
}

export default CheckoutReport;
